module.exports = __webpack_public_path__ + "static/media/eyePasswordClose.2d4ac6fc.svg";